// extracted by mini-css-extract-plugin
export default {"modalArea":"ModalEnableMunicipality_modalArea__SQkM-","buttons":"ModalEnableMunicipality_buttons__k951L"};